export default {"src":"/_next/static/media/Arrow-left.7a316073.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};